<template>
    <DefaultLayout :meta="meta">

        <section class="md:mt-8">
            <div class="w-full max-w-screen-xl mx-auto px-6">
                <div class="h-auto grid grid-cols-1 md:grid-cols-2 gap-y-12">
                    <div class="h-auto order-2 md:order-1">
                        <div class="w-full h-full mx-auto flex flex-col items-center justify-center">
                            <div class="w-full md:w-2/3 mx-auto flex flex-col items-center justify-center">
                                <div class="hidden md:block trustpilot-widget" data-locale="da-DK" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="619813800c5541f7f6f02b42" data-style-height="24px" data-style-width="100%">
                                    <a href="https://www.trustpilot.com/review/fototiles.dk" target="_blank" rel="noopener">Trustpilot</a>
                                </div>

                                <h1 class="text-2xl md:text-3xl font-bold uppercase text-center md:mt-6">{{ __('home::index.hero_title') }}</h1>
                                <p class="mt-6 md:mt-8 text-center whitespace-pre-line">{{ __('home::index.hero_description') }}</p>

                                <CTA :href="$route('home::orders.create')" variant="large" class="hidden md:flex mt-8">
                                    {{ __('home::index.order_now') }}
                                    <ChevronRightIcon class="h-4 w-4 ml-2" />
                                </CTA>
                            </div>

                            <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:px-6 mt-12">
                                <div
                                    v-for="(item, index) in uspItems"
                                    :key="index"
                                    class="flex flex-row lg:flex-col lg:items-center gap-2"
                                >
                                    <div class="flex-shrink-0">
                                        <CheckCircleIcon class="h-6 w-6 text-cta" />
                                    </div>

                                    <div class="text-base font-medium text-center">
                                        {{ item }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="order-1 md:order-2">
                        <div class="relative">
                            <img src="/media/hero.jpg" alt="Fototiles" width="750" height="750" class="w-full h-auto" />

                            <div class="absolute top-2 right-2">
                                <div
                                    class="px-4 py-2 rounded-sm shadow-sm font-bold text-center whitespace-pre-line"
                                    :class="[$page.props.__site.promotion_style === 'black_friday'
                                            ? 'text-black bg-[#ffd732]'
                                            : 'text-primary bg-primary-light']"
                                    v-if="! delayedPaymentDays"
                                    v-html="__('home::index.price_info')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--
        <section>
            <div class="w-full max-w-screen-xl mx-auto px-6">
                <TrustBox />
            </div>
        </section>
        -->

        <USPSection class="border-t border-b border-gray-200" />

        <SliderSection class="border-b border-gray-200" />

        <section class="py-16">
            <div class="w-full max-w-screen-xl mx-auto px-6">
                <h2 class="text-2xl font-bold text-center mb-16">
                    {{ __('home::index.see_how_easy_it_is') }}
                </h2>

                <div class="video-wrapper">
                    <video muted playsinline controls ref="video">
                        <source :src="'/media/' + $page.props.__media_folder + '/hero-video3.mp4'" type="video/mp4">
                    </video>
                </div>
            </div>
        </section>

        <ProductSection
            shape="3"
            image="/media/home-square.png"
            imageAlt="Squares"
            :title="__('home::index.product_section_3_title')"
            :description="__('home::index.product_section_3_description')"
            :price="__('home::index.product_section_3_price')"
            :cta-text="__('home::index.order_photowall_now')"
            class="mt-8"
            image-position="left"
        />

        <ProductSection
            shape="1"
            image="/media/home-hexagon.png"
            imageAlt="Hexagons"
            :title="__('home::index.product_section_2_title')"
            :description="__('home::index.product_section_2_description')"
            :price="__('home::index.product_section_2_price')"
            :cta-text="__('home::index.order_photowall_now')"
            class="bg-gray-50"
            image-position="right"
        />

        <!--
        <ProductSection
            shape="9"
            image="/media/index-frames.png"
            imageAlt="Frames"
            :title="__('home::index.product_section_1_title')"
            :description="__('home::index.product_section_1_description')"
            :price="__('home::index.product_section_1_price')"
            :cta-text="__('home::index.order_photowall_now')"
            cta-text="Lav din billedvæg nu"
            image-position="left"
        />
        -->

        <ProductGuideSection />

        <Faq class="mb-16 pt-16 border-t border-gray-200" />

        <!-- Mobile sticky actions -->
        <div class="block md:hidden sticky z-10 bottom-0 left-0 w-full border-t border-primary-light">
            <CTA :href="$route('home::orders.create')" variant="large" class="!py-4">
                {{ __('home::index.order_now') }}
                <ChevronRightIcon class="h-4 w-4 ml-2" />
            </CTA>
        </div>

    </DefaultLayout>
</template>

<script>
import {
    ArrowNarrowRightIcon,
    ChevronRightIcon,
    CheckCircleIcon,
} from '@heroicons/vue/outline'

    export default {
        components: {
            ArrowNarrowRightIcon,
            ChevronRightIcon,
            CheckCircleIcon,
        },
        props: {
            meta: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {
                uspItems: [
                    this.__('home::index.usp_1'),
                    this.__('home::index.usp_2'),
                    this.__('home::index.usp_3'),
                ],
            };
        },
        mounted() {
            document.addEventListener('scroll', this.startVideoWhenInViewport);
        },
        beforeUnmount() {
            document.removeEventListener('scroll', this.startVideoWhenInViewport);
        },
        methods: {
            startVideoWhenInViewport() {

                let el = this.$refs.video;
                let rect = el.getBoundingClientRect();
                let requiredOffset = 50;
                let isInViewport = (rect.top - window.innerHeight + requiredOffset) < 0 ? true : false;

                if (isInViewport) {
                    el.play();
                    document.removeEventListener('scroll', this.startVideoWhenInViewport);
                }

            },
        },
    }
</script>
